import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@src/environments/environment';
import { Observable } from 'rxjs';
import { NpoSearchResults } from '../models/npo-search-results.model';

@Injectable({
    providedIn: 'root',
})
export class NpoSearchService {
    constructor(private readonly httpClient: HttpClient) {}

    private readonly pageSize = 10;
    private readonly channelSource = {
        channelType: 'WEB',
        channelSubType: 'DIGITAL_NPO_ENROLLMENT',
        sourcePartyType: 'NPO',
    };

    npoSearch(ein: string, pageNumber: number): Observable<NpoSearchResults> {
        const body = {
            filters: ['excludeNonPrimaryADD'],
            channelSource: this.channelSource,
            size: this.pageSize,
            page: pageNumber,
            terms: ein,
        };
        return this.httpClient.post<NpoSearchResults>(environment.baseUrlV3 + '/npo/search', body);
    }
}
